import { render } from "./RukuForm.vue?vue&type=template&id=4dbc2931&ts=true"
import script from "./RukuForm.vue?vue&type=script&lang=ts"
export * from "./RukuForm.vue?vue&type=script&lang=ts"
/* custom blocks */
import block0 from "./RukuForm.vue?vue&type=custom&index=0&blockType=style.&lang=scss"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__